import { post, del, get, put } from "./api_helper"
import * as url from "./url_helper"

export const registerStudent = data => post(url.STUDENT_REGISTER, data);
export const loginStudent = data => post(url.STUDENT_LOGIN, data);
export const tataloginStudent = data => post(url.TATASTUDENT_TataLOGIN, data);

export const getAllCourseOfStudent = id => get(url.GET_ALL_COURSE_OF_STUDENT + id);
export const getAllScormCourseOfStudent = id => get(url.GET_ALL_SCORM_COURSE_OF_STUDENT + id);
export const getAllClassesOfStudent = id => get(url.GET_ALL_CLASSES_OF_STUDENT + id);
export const getAllExamOfStudent = id => get(url.GET_ALL_EXAMS_OF_STUDENT + id);
export const getAllMyCourses = () => get(url.GET_ALL_MY_COURSES);
export const getSingleStudent = id => get(url.GET_SINGLE_SUTDENT + id);
export const updateStudent = data => put(url.UPDATE_STUDENT, data);


export const forgotPassword = email => post(url.FORGOT_PASSWORD + email);
export const resetPassword = data => post(url.RESET_PASSWORD, data);




